import { render, staticRenderFns } from "./TeacherCardMobile.vue?vue&type=template&id=b8b1fe8c&"
import script from "./TeacherCardMobile.vue?vue&type=script&lang=js&"
export * from "./TeacherCardMobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports